import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = "http://localhost:8080/auth/change-password"; // ✅ Fixed API URL

// ✅ Async function for changing password
export const changePassword = createAsyncThunk(
  "changePassword/change",
  async ({ email, newPassword }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token"); // ✅ Get JWT token
      const response = await axios.post(
        API_URL,
        null, // ✅ No request body, using query params
        {
          params: { email, newPassword },
          headers: { Authorization: `Bearer ${token}` }, // ✅ Send JWT token
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to change password");
    }
  }
);

const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState: {
    loading: false,
    message: null,
    error: null,
  },
  reducers: {
    clearMessages: (state) => {
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.message = "Password changed successfully.";
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMessages } = changePasswordSlice.actions;
export default changePasswordSlice.reducer;
